import React, { createContext, useEffect, useState, useContext } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { firebase, checkEntry } from '../services/firebaseService';
import { getBrowserLocale, sendMessageToImageText } from '../services/helper';
import StorageManager from '../services/StorageManager';
import { USER_LANGUAGE } from '../services/StorageKeys';
import Loader from 'ui-component/Loader';

export const AuthContext = createContext();
const auth = firebase.auth();

export function useAuth() {
    return useContext(AuthContext);
}

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [user, loading] = useAuthState(auth);

    useEffect(() => {
        let isMounted = true;

        const init = async () => {
            if (user) {
                const { exists, isPaid, locale } = await checkEntry('users', user?.email);
                user.paid = isPaid;
                user.hasWorkspace = exists;
                user.locale = locale || getBrowserLocale();
                StorageManager.put(USER_LANGUAGE, user.locale);
                // send signal to extension to change url to ad-free endpoint
                if (typeof chrome !== 'undefined') {
                    sendMessageToImageText(
                        '/upgrade',
                        {
                            endpoint: user.paid ? 'https://app.imagetext.xyz' : 'https://imagetext.xyz'
                        },
                        () => {}
                    );
                }
            }

            if (isMounted) {
                setCurrentUser(user);
                if (!loading) {
                    setIsLoading(false);
                }
            }
        };

        init().catch((e) => console.log(e));

        return () => {
            isMounted = false;
        };
    }, [user, loading]);

    if (isLoading || loading) {
        return <Loader />;
    }

    return (
        <AuthContext.Provider
            value={{
                currentUser
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};
